// AJMUS static content. All copy lives here so sections stay reusable/editable.

export const CONTACT = {
  phone: "9012665065",
  whatsapp: "9012665065",
  email: "contact@ajmus.com",
  address: "R-17, L D PARK - 1, DEESA-385535",
};

export const DEMO_PRODUCTS = [
  {
    key: "pharmacy",
    name: "AJMUS Pharmacy",
    status: "Available now",
    description: "Explore POS billing, purchases, inventory, batch and expiry, returns, rack management and reports with controlled demo data.",
    url: "https://pharmacy.ajmus.com/pharmacy",
    available: true,
  },
  {
    key: "laboratory",
    name: "AJMUS Laboratory",
    status: "Available now",
    description: "Explore registration, sample collection, result entry, formulas, review and reporting in the AJMUS Laboratory live demo.",
    url: "https://laboratory.ajmus.com/laboratory",
    available: true,
  },
  {
    key: "hospital",
    name: "AJMUS Hospital Lite / HMS",
    status: "Available now",
    description: "Explore OPD, IPD, nursing, OT and connected hospital operations in the AJMUS Hospital live demo.",
    url: "https://hospital.ajmus.com/hospital",
    available: true,
  },
  {
    key: "school",
    name: "AJMUS School Management Software",
    status: "Coming soon",
    description: "Admissions, student records, attendance, fees, academics, examinations, staff, communication and school operations.",
    url: "",
    available: false,
  },
];

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "Healthcare", id: "healthcare" },
  { label: "Education", id: "education" },
  { label: "Platform", id: "platform" },
  { label: "Why AJMUS", id: "why" },
  { label: "Contact", id: "contact" },
];

export const MARQUEE_ITEMS = [
  "Hospital Management",
  "OPD & IPD",
  "Pharmacy POS",
  "Laboratory & Diagnostics",
  "Admissions",
  "Fees & Accounts",
  "Examinations",
  "HR & Payroll",
  "Inventory & Procurement",
  "Reports & Analytics",
  "Parent & Student Portals",
  "Transport, Library & Hostel",
];

export const HEALTHCARE_MODULES = [
  {
    key: "hospital",
    icon: "Hospital",
    title: "Hospital Management",
    summary: "Run the full hospital workflow from registration to discharge and billing.",
    features: [
      "Patient registration",
      "Appointments",
      "OPD management",
      "IPD management",
      "Bed & ward management",
      "Doctor & practitioner management",
      "Nursing workflows",
      "Emergency workflows",
      "Discharge processes",
      "Patient billing",
      "Insurance & TPA workflow support",
      "Medical records",
      "Operational reports",
    ],
  },
  {
    key: "opd",
    icon: "Stethoscope",
    title: "OPD Management",
    summary: "Fast front-desk to consultation flow with queues and follow-ups.",
    features: [
      "Fast patient registration",
      "Appointment scheduling",
      "Queue management",
      "Consultation records",
      "Prescriptions",
      "Follow-up management",
      "Billing integration",
      "Patient history",
    ],
  },
  {
    key: "ipd",
    icon: "BedDouble",
    title: "IPD Management",
    summary: "Manage admissions, wards, nursing records and in-patient charges.",
    features: [
      "Admission & discharge",
      "Bed allocation",
      "Ward management",
      "Nursing records",
      "Treatment orders",
      "Medication tracking",
      "Charges & billing",
      "Patient progress visibility",
    ],
  },
  {
    key: "pharmacy",
    icon: "Pill",
    title: "Pharmacy Management",
    summary: "Full pharmacy POS with batch, expiry and supplier control.",
    features: [
      "Pharmacy POS",
      "Medicine inventory",
      "Batch tracking",
      "Expiry tracking",
      "Purchase management",
      "Sales & returns",
      "Barcode support",
      "Reorder alerts",
      "Supplier management",
      "GST-ready billing support",
      "Stock reports",
    ],
  },
  {
    key: "lab",
    icon: "FlaskConical",
    title: "Laboratory Management",
    summary: "Diagnostics from sample collection to validated digital reports.",
    features: [
      "Patient & test registration",
      "Sample collection",
      "Barcode generation",
      "Sample tracking",
      "Test processing",
      "Numeric & selectable results",
      "Formula-based calculations",
      "Reference ranges",
      "Critical-value identification",
      "Result validation",
      "Digital laboratory reports",
      "Analyzer integration readiness",
      "Laboratory billing",
      "Operational analytics",
    ],
  },
  {
    key: "hr",
    icon: "Users",
    title: "HR & Payroll",
    summary: "Workforce, attendance and payroll for clinical & non-clinical staff.",
    features: [
      "Employee records",
      "Attendance",
      "Shifts",
      "Leave management",
      "Payroll",
      "Departments",
      "Roles & permissions",
      "Performance tracking",
      "Staff reports",
    ],
  },
  {
    key: "inventory",
    icon: "Boxes",
    title: "Inventory & Procurement",
    summary: "Track items, purchases and stock across every department.",
    features: [
      "Item management",
      "Purchase workflows",
      "Supplier management",
      "Stock transfers",
      "Batch & expiry control",
      "Reorder levels",
      "Consumption tracking",
      "Inventory reports",
    ],
  },
  {
    key: "billing",
    icon: "LineChart",
    title: "Billing, Accounts & Analytics",
    summary: "Connected billing, receivables and management dashboards.",
    features: [
      "Patient billing",
      "Service billing",
      "Receivables",
      "Expense tracking",
      "Financial reports",
      "Department-level reporting",
      "Management dashboards",
      "Operational insights",
    ],
  },
];

export const EDUCATION_MODULES = [
  {
    key: "admission",
    icon: "ClipboardList",
    title: "Admission Management",
    summary: "From enquiry to onboarding with applicant tracking.",
    features: [
      "Admission enquiries",
      "Online applications",
      "Applicant tracking",
      "Document collection",
      "Admission decisions",
      "Student onboarding",
      "Admission reporting",
    ],
  },
  {
    key: "sis",
    icon: "GraduationCap",
    title: "Student Information System",
    summary: "A single record for every student and guardian.",
    features: [
      "Student profiles",
      "Guardian information",
      "Class & section allocation",
      "Academic records",
      "Student history",
      "Document management",
      "Promotion & transfer workflows",
    ],
  },
  {
    key: "attendance",
    icon: "CalendarCheck",
    title: "Attendance Management",
    summary: "Daily, subject-wise and staff attendance with alerts.",
    features: [
      "Daily attendance",
      "Subject-wise attendance",
      "Staff attendance",
      "Late-entry tracking",
      "Absence notifications",
      "Attendance reports",
    ],
  },
  {
    key: "fees",
    icon: "Receipt",
    title: "Fees & Accounts",
    summary: "Flexible fee structures, receipts and outstanding tracking.",
    features: [
      "Fee structures",
      "Fee collection",
      "Concessions",
      "Scholarships",
      "Outstanding-fee tracking",
      "Receipts",
      "Payment history",
      "Financial reports",
    ],
  },
  {
    key: "timetable",
    icon: "CalendarDays",
    title: "Timetable & Academic Planning",
    summary: "Plan classes, teachers, rooms and substitutions.",
    features: [
      "Class timetables",
      "Teacher timetables",
      "Subject allocation",
      "Room allocation",
      "Academic calendars",
      "Substitution management",
    ],
  },
  {
    key: "exam",
    icon: "PenLine",
    title: "Examination & Grade Management",
    summary: "Plan exams, enter marks and publish report cards.",
    features: [
      "Examination planning",
      "Marks entry",
      "Grade calculation",
      "Report cards",
      "Progress reports",
      "Result analysis",
      "Subject performance reports",
    ],
  },
  {
    key: "learning",
    icon: "BookOpen",
    title: "Learning & Communication",
    summary: "Assignments, notices and parent-teacher communication.",
    features: [
      "Homework & assignments",
      "Study materials",
      "Notices",
      "Announcements",
      "Parent communication",
      "Student communication",
      "Teacher collaboration",
      "Events & calendars",
    ],
  },
  {
    key: "portals",
    icon: "MonitorSmartphone",
    title: "Parent, Student & Teacher Access",
    summary: "Role-based portals for the whole school community.",
    features: [
      "Academic information",
      "Attendance visibility",
      "Fee status",
      "Assignments",
      "Notices",
      "Examination results",
      "Communication tools",
    ],
  },
  {
    key: "transport",
    icon: "Bus",
    title: "Transport, Library & Hostel",
    summary: "Manage routes, catalogues and hostel allocation.",
    features: [
      "Routes & vehicles",
      "Student transport allocation",
      "Driver information",
      "Library catalogues",
      "Book issue & return",
      "Hostel rooms",
      "Hostel allocation",
      "Related reports",
    ],
  },
  {
    key: "schoolhr",
    icon: "Users",
    title: "School HR & Payroll",
    summary: "Staff records, leave and payroll for teaching & non-teaching teams.",
    features: [
      "Teaching & non-teaching staff",
      "Attendance",
      "Leave",
      "Payroll",
      "Departments",
      "Work schedules",
      "Employee records",
    ],
  },
];

export const PLATFORM_NODES = [
  { icon: "PanelsTopLeft", label: "Front Desk" },
  { icon: "Workflow", label: "Operations" },
  { icon: "Wallet", label: "Finance" },
  { icon: "Boxes", label: "Inventory" },
  { icon: "Users", label: "HR" },
  { icon: "BarChart3", label: "Reports" },
  { icon: "MessageSquare", label: "Communication" },
  { icon: "LayoutDashboard", label: "Management Dashboard" },
];

export const PLATFORM_BENEFITS = [
  "Centralised information",
  "Reduced duplicate data entry",
  "Faster daily operations",
  "Better coordination between departments",
  "Role-based access",
  "Real-time visibility",
  "Consistent reporting",
  "Scalable architecture",
];

export const WHY_AJMUS = [
  {
    icon: "Workflow",
    title: "Designed Around Real Operations",
    body: "Software workflows reflect how hospitals, laboratories, pharmacies and schools actually work.",
  },
  {
    icon: "Blocks",
    title: "Modular and Scalable",
    body: "Begin with essential modules and expand as your requirements grow.",
  },
  {
    icon: "MousePointerClick",
    title: "Easy for Teams to Use",
    body: "Clean, focused and responsive interfaces suited to daily operational work.",
  },
  {
    icon: "Eye",
    title: "Better Management Visibility",
    body: "Clear reports, dashboards and operational information for faster decisions.",
  },
  {
    icon: "Network",
    title: "Connected Departments",
    body: "Reduce disconnected records and improve coordination between teams.",
  },
  {
    icon: "LifeBuoy",
    title: "Implementation and Support",
    body: "A long-term technology partner for configuration, deployment, training and improvement.",
  },
];

export const PROCESS_STEPS = [
  { no: "01", title: "Understand", body: "AJMUS studies the organisation's workflows and requirements." },
  { no: "02", title: "Configure", body: "Relevant modules and processes are configured for the organisation." },
  { no: "03", title: "Implement", body: "Data, users, permissions and operational workflows are prepared." },
  { no: "04", title: "Support & Improve", body: "Teams receive assistance, training and continuous system improvements." },
];

export const ROLES = [
  {
    key: "hospital-admin",
    label: "Hospital Administrator",
    icon: "Hospital",
    domain: "healthcare",
    items: [
      { k: "Bed visibility", v: "78 / 120 occupied" },
      { k: "Department performance", v: "12 departments tracked" },
      { k: "Billing status", v: "Today's collections up to date" },
      { k: "Staff information", v: "On-duty roster synced" },
      { k: "Inventory alerts", v: "3 items below reorder level" },
    ],
  },
  {
    key: "doctor",
    label: "Doctor",
    icon: "Stethoscope",
    domain: "healthcare",
    items: [
      { k: "Today's appointments", v: "Consultation queue ready" },
      { k: "Patient history", v: "Records available at a glance" },
      { k: "Prescriptions", v: "Digital prescribing enabled" },
      { k: "Lab results", v: "Linked to patient records" },
      { k: "Follow-ups", v: "Scheduled reminders" },
    ],
  },
  {
    key: "lab-manager",
    label: "Laboratory Manager",
    icon: "FlaskConical",
    domain: "healthcare",
    items: [
      { k: "Pending samples", v: "Live sample tracker" },
      { k: "Result status", v: "Awaiting validation" },
      { k: "Critical results", v: "Flagged automatically" },
      { k: "Test turnaround", v: "Monitored per test" },
      { k: "Laboratory reports", v: "Digital & shareable" },
    ],
  },
  {
    key: "pharmacist",
    label: "Pharmacist",
    icon: "Pill",
    domain: "healthcare",
    items: [
      { k: "Pharmacy POS", v: "Fast billing counter" },
      { k: "Stock on hand", v: "Batch & expiry aware" },
      { k: "Reorder alerts", v: "Low-stock notifications" },
      { k: "Sales & returns", v: "Recorded in real time" },
      { k: "Supplier orders", v: "Purchase workflow ready" },
    ],
  },
  {
    key: "school-admin",
    label: "School Administrator",
    icon: "GraduationCap",
    domain: "education",
    items: [
      { k: "Admissions", v: "Applicant pipeline visible" },
      { k: "Attendance", v: "School-wide snapshot" },
      { k: "Fee collection", v: "Outstanding tracked" },
      { k: "Academic progress", v: "Result analysis ready" },
      { k: "Staff information", v: "Rosters & leave synced" },
    ],
  },
  {
    key: "teacher",
    label: "Teacher",
    icon: "PenLine",
    domain: "education",
    items: [
      { k: "Class attendance", v: "Mark in seconds" },
      { k: "Assignments", v: "Publish & track" },
      { k: "Marks entry", v: "Grades calculated" },
      { k: "Timetable", v: "Personal schedule" },
      { k: "Communication", v: "Reach parents easily" },
    ],
  },
  {
    key: "parent",
    label: "Parent",
    icon: "Users",
    domain: "education",
    items: [
      { k: "Academic info", v: "Progress at a glance" },
      { k: "Attendance", v: "Daily visibility" },
      { k: "Fee status", v: "Receipts & dues" },
      { k: "Notices", v: "Instant announcements" },
      { k: "Results", v: "Report cards online" },
    ],
  },
  {
    key: "management",
    label: "Management Team",
    icon: "LayoutDashboard",
    domain: "both",
    items: [
      { k: "Operational insights", v: "Cross-department view" },
      { k: "Financial reports", v: "Consolidated figures" },
      { k: "Utilisation", v: "Resource & capacity trends" },
      { k: "Multi-branch", v: "Compare locations" },
      { k: "Dashboards", v: "Decision-ready summaries" },
    ],
  },
];

export const CAPABILITIES = [
  { icon: "Smartphone", title: "Responsive & mobile-friendly interfaces" },
  { icon: "ShieldCheck", title: "Role-based access" },
  { icon: "SlidersHorizontal", title: "Configurable workflows" },
  { icon: "BarChart3", title: "Reporting & analytics" },
  { icon: "Bell", title: "Notifications & communication" },
  { icon: "Upload", title: "Data import support" },
  { icon: "Plug", title: "Integration readiness" },
  { icon: "Cloud", title: "Cloud or organisation-hosted deployment" },
  { icon: "DatabaseBackup", title: "Backup & operational continuity planning" },
  { icon: "GitBranch", title: "Multi-branch readiness" },
];

export const FAQS = [
  {
    q: "What types of organisations can use AJMUS?",
    a: "AJMUS is built for hospitals, clinics, diagnostic laboratories, pharmacies, schools, colleges and other educational institutions that need connected operational software.",
  },
  {
    q: "Can we start with only selected modules?",
    a: "Yes. The platform is modular, so you can begin with the modules you need most and add more as your requirements grow.",
  },
  {
    q: "Can AJMUS support multiple branches?",
    a: "The platform is designed with multi-branch readiness so organisations operating from more than one location can be supported.",
  },
  {
    q: "Does AJMUS provide implementation assistance?",
    a: "Yes. AJMUS works as a technology partner and assists with configuration, deployment and onboarding.",
  },
  {
    q: "Can the software be configured for our workflows?",
    a: "Workflows are configurable so the system can be aligned with how your teams already operate.",
  },
  {
    q: "Is training available for staff?",
    a: "Training and guidance are part of the implementation and support process to help your teams adopt the system.",
  },
  {
    q: "Can existing data be imported?",
    a: "Data import is supported to help bring your existing records into the platform during onboarding.",
  },
  {
    q: "How can we request a product demonstration?",
    a: "Use the Live Demo or Contact options on this page, or reach us directly and our team will arrange a walkthrough.",
  },
];

export const FOOTER_SOLUTIONS = [
  "Hospital Management",
  "OPD and IPD",
  "Pharmacy Management",
  "Laboratory Management",
  "School Management",
  "HR and Payroll",
];

export const FOOTER_COMPANY = [
  { label: "About AJMUS", id: "why" },
  { label: "Why AJMUS", id: "why" },
  { label: "Contact", id: "contact" },
  { label: "Live Demo", id: "contact" },
];
